export class StringUtil {

    static format(str: string, params: { [id: string]: string; }): string {
        for (let key in params) {
            str = str.replace(new RegExp("\\{" + key + "\\}", "gi"), params[key]);
        }
        return str;
    }

    static normalizeInternetMessageId(messageId: string): string {
        if (!messageId)
            return ""; //as we only want to return string, return "", as !("") === true
        else
            return messageId.replace('<', '').replace('>', '');
    }

    static globalReplace(incomingString: string, searchString: string, replacerString: string): string {
        let globalRegexp = new RegExp(this.regexpEscape(searchString), "g");

        return incomingString.replace(globalRegexp, replacerString);
    }

    /**escapes all the characters reserved for RegExp */
    static regexpEscape(stringToPutIntoRegExp: string): string {
        if (!stringToPutIntoRegExp)
            return "";
        else
            return stringToPutIntoRegExp.replace(/[\\^$*+?.()|[\]{}]/g, '\\$&'); //see https://github.com/benjamingr/RexExp.escape
    }

    static async parseXML(xmlString: string): Promise<Document> {
        //Not sure how long this can take?! Make async
        //Todo: Does that even help?
        return new Promise<Document>((resolve, reject) => {
            setTimeout(() => {
                let parser = new DOMParser();
                resolve(parser.parseFromString(xmlString, 'text/xml'));
            }, 1);
        });
    }
}
